import React, { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

const IsClockedInContext = createContext<{ isClockedIn: boolean, setIsClockedIn: (val: boolean) => void }>({ isClockedIn: false, setIsClockedIn: () => {} });

const IsClockedInProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isClockedIn, setIsClockedIn] = useState(false);
  return <IsClockedInContext.Provider value={{ isClockedIn, setIsClockedIn }}>{children}</IsClockedInContext.Provider>;
};

const useIsClockedIn = () => useContext(IsClockedInContext);

export { IsClockedInProvider, useIsClockedIn };
